import type {
    FinishThreeTResponseType,
    FinishThreeTRequestType
} from "./type";
import {
    request
} from "../request";

const threeTFinish = async (args: FinishThreeTRequestType): Promise<FinishThreeTResponseType> => {
    return await request<FinishThreeTResponseType>("/threeT/finishThreeT", {
        body: JSON.stringify(args),
        method: "POST"
    });
};

export default threeTFinish;
